import { render, staticRenderFns } from "./RegistrarOrdenPago.vue?vue&type=template&id=1599cfed&scoped=true&"
import script from "./RegistrarOrdenPago.vue?vue&type=script&lang=js&"
export * from "./RegistrarOrdenPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1599cfed",
  null
  
)

export default component.exports